import React, { useState, useCallback } from 'react'
import HotkeysIcon from '@bufferapp/ui/Icon/Icons/Hotkeys'
import Tooltip from '@bufferapp/ui/Tooltip'
import { grayDark, grayDarker } from '@bufferapp/ui/style/colors'

import {
  Modal,
  Form,
  FormSection,
  FormControls,
  Button,
  Text,
} from '~/shared/components'

import { Option, OptionButton } from '../styles'
import { Image } from './styles'

const HOTKEYS_IMG = 'https://static.buffer.com/images/engage/hotkeys.png'

/**
 *
 */
const Hotkeys = () => {
  const [modalOpened, setModalOpened] = useState(false)

  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
  const onClick = useCallback(() => {
    setModalOpened(true)
  })

  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
  const onClose = useCallback(() => {
    setModalOpened(false)
  })

  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
  const onSubmit = useCallback((event) => {
    event.preventDefault()
    onClose()
  })

  const renderModal = () => (
    <Modal onClose={onClose}>
      {/* @ts-expect-error TS(2741) FIXME: Property 'method' is missing in type '{ children: ... Remove this comment to see the full error message */}
      <Form onSubmit={onSubmit}>
        {/* @ts-expect-error TS(2741) FIXME: Property 'withBg' is missing in type '{ children: ... Remove this comment to see the full error message */}
        <FormSection>
          {/* @ts-expect-error TS(2741) FIXME: Property 'className' is missing in type '{ childre... Remove this comment to see the full error message */}
          <Text size={18} weight="bold" color={grayDarker}>
            Speed up your engagement with hotkeys!
          </Text>
          {/* @ts-expect-error TS(2741) FIXME: Property 'className' is missing in type '{ childre... Remove this comment to see the full error message */}
          <Text size={14} color={grayDark}>
            These hotkeys will allow you to engage with comments even faster,
            without having to move your mouse!
          </Text>
        </FormSection>
        <FormSection withBg>
          <Image
            src={HOTKEYS_IMG}
            alt={
              'Navigate comments wit up and down arrow keys, \
              dismiss comments using CTRL + D on your keyboard and \
              hit Enter to send a reply'
            }
          />
        </FormSection>
        {/* @ts-expect-error TS(2741) FIXME: Property 'withBg' is missing in type '{ children: ... Remove this comment to see the full error message */}
        <FormSection>
          {/* @ts-expect-error TS(2741) FIXME: Property 'spaced' is missing in type '{ children: ... Remove this comment to see the full error message */}
          <FormControls>
            <Button
              // @ts-expect-error TS(2322) FIXME: Type '{ type: string; variant: string; label: stri... Remove this comment to see the full error message
              type="submit"
              variant="primary"
              label="Close"
              data-testid="close-button"
              autoFocus
            />
          </FormControls>
        </FormSection>
      </Form>
    </Modal>
  )

  return (
    <>
      <Option>
        <Tooltip label="Hotkeys" position="top">
          <OptionButton onClick={onClick} aria-label="Hotkeys">
            <HotkeysIcon size="medium" />
          </OptionButton>
        </Tooltip>
      </Option>
      {modalOpened && renderModal()}
    </>
  )
}

Hotkeys.propTypes = {}

Hotkeys.defaultProps = {}

export default Hotkeys
